var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showCalendar)?_c('div',[_c('FullCalendar',{ref:"fullCalendar",attrs:{"options":_vm.calendarOptions}}),_vm._v(" "),_c('prompt-with-select',{ref:"prompt_with_select"})],1):(_vm.isLoading)?_c('div',{staticClass:"text-center"},[_c('scale-loader')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }